export const getDeleteConfirmCopy = (displayName) => ({
  title: 'Confirm deletion',
  message: `Are you sure you want to delete ${displayName}?`,
});

export const getLogoutConfirmCopy = () => ({
  title: 'Confirm logout',
  message: 'Are you sure you want to logout?',
});
